<p-dialog
        [(visible)]="visible"
        [modal]="true"
        [header]="'Create New Vehicle Model'"
        [closable]="true"
        [resizable]="false"
        [draggable]="false"
        [style]="{ width: '600px' }"
        (onHide)="close()"
>
    <div class="flex flex-col gap-6 my-3">
        <!-- Model Series -->
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-pencil"></p-inputicon>
                <input
                        pInputText
                        id="modelSeries"
                        [(ngModel)]="vehicleModel.modelSeries"
                        autocomplete="off"
                        class="w-full"
                />
            </p-iconfield>
            <label for="modelSeries">Model Series <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [options]="carClasses"
                    [(ngModel)]="vehicleModel.carClassId"
                    (ngModelChange)="onCarClassOrBodyTypeChange()"
                    optionLabel="label"
                    optionValue="id"
                    id="carClass"
                    class="w-full"
                    placeholder="Select Car Class"
                    filter
                    appendTo="body">
            </p-select>
            <label for="carClass">Car Class <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [options]="bodyTypes"
                    [(ngModel)]="vehicleModel.bodyTypeId"
                    (ngModelChange)="onCarClassOrBodyTypeChange()"
                    optionLabel="label"
                    optionValue="id"
                    id="bodyType"
                    class="w-full"
                    placeholder="Select Body Type"
                    filter
                    appendTo="body">
            </p-select>
            <label for="bodyType">Body Type <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <p-ifta-label>
            <p-select
                    [options]="brands"
                    [(ngModel)]="vehicleModel.brandId"
                    optionLabel="label"
                    optionValue="id"
                    id="brand"
                    class="w-full"
                    placeholder="Select Brand"
                    filter
                    appendTo="body">
            </p-select>
            <label for="brand">Brand <span class="text-red-500">*</span></label>
        </p-ifta-label>


        <!-- Label -->
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-pencil"></p-inputicon>
                <input
                        pInputText
                        id="label"
                        [(ngModel)]="vehicleModel.label"
                        autocomplete="off"
                        class="w-full"
                />
            </p-iconfield>
            <label for="label">Label <span class="text-red-500">*</span></label>
        </p-ifta-label>

        <div class="grid grid-cols-2 gap-4">
            <!-- Availability Date -->
            <p-ifta-label>
                <p-date-picker
                        [(ngModel)]="this.availabilityDate"
                        id="availability-date"
                        class="w-full"
                        dateFormat="dd.mm.yy"
                        appendTo="body"
                ></p-date-picker>
                <label for="availability-date">Availability Date</label>
            </p-ifta-label>

            <!-- Expiration Date -->
            <p-ifta-label>
                <p-date-picker
                        [(ngModel)]="this.expirationDate"
                        id="expiration-date"
                        class="w-full"
                        dateFormat="dd.mm.yy"
                        appendTo="body"
                ></p-date-picker>
                <label for="expiration-date">Expiration Date</label>
            </p-ifta-label>
        </div>
        <app-select-or-upload-media [(selectedMedia)]="this.media"></app-select-or-upload-media>
        <p class="text-gray-400 text-xs">With <span class="text-red-500">*</span> marked fields are
            mandatory.</p>
    </div>

    <div class="flex justify-end gap-2 mt-10">
        <p-button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                (click)="close()"
                severity="secondary"
        ></p-button>
        <p-button
                label="Save"
                icon="pi pi-check"
                (click)="saveVehicleModel()"
                [loading]="loading"
                [disabled]="saveDisabled"
        ></p-button>
    </div>
</p-dialog>
